import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-about-miracle',
  templateUrl: './about-miracle.component.html',
  styleUrls: ['./about-miracle.component.scss'],
      encapsulation: ViewEncapsulation.None,
  
})
export class AboutMiracleComponent implements OnInit {

  public ads: any[] = [];
about: any = {
  id: null,
  title_ar: '',
  title_en: '',
  content_ar: '',
  content_en: ''
};

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private translate: TranslateService,
                private toastr: ToastrService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;

  public tempData = [];
   vision: any = { 'ar': '', 'en': '', title: '' };
  goals: any = { 'ar': '', 'en': '', title: '' };
  lang: string = 'en'; // default

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

ngOnInit(): void {

  this.apisService.Nabout().subscribe({
    next: (res: any) => {
      const d = res.data;

      this.about = {
        id: d.id,
        title_ar: d.title_ar,
        title_en: d.title_en,
        content_ar: d.content_ar,
        content_en: d.content_en
      };

      console.log("ABOUT:", this.about);
    },
    error: err => console.error(err)
  });
}


  saveAll() {
    const payload = {
      content_ar: this.vision.ar, 
      content_en: this.vision.en,
      title_ar: this.goals.ar,
      title_en: this.goals.en
    };

    console.log('Saving payload:', payload);

    // Example API calls
    this.apisService.editNaboutVisions(payload).subscribe({
      next: () => console.log('Vision saved successfully!'),
      error: (err) => console.error('Error saving vision:', err)
    });

    this.apisService.editNaboutGoals(payload).subscribe({
      next: () => console.log('Goals saved successfully!'),
      error: (err) => console.error('Error saving goals:', err)
    });

  }

  
  updateAbout() {
  if (!this.about.id) {
    this.toastr.error(this.translate.instant('MENU.DASHBOARD.missing_record_id'));
    return;
  }

  this.apisService.editNabout(this.about).subscribe({
    next: () => {
      this.toastr.success(
        this.translate.instant('MENU.DASHBOARD.record_updated_successfully')
      );
    },
    error: (err) => {
      console.error(err);
      this.toastr.error(
        this.translate.instant('MENU.DASHBOARD.failed_to_update_record')
      );
    }
  });
}



updateProductt(): void {
  if (!this.vision?.id) {
    this.toastr.error('Missing record ID');
    return;
  }

  const data = {
    id: this.vision.id, // ✅ include ID here
    title_ar: this.vision.title_ar || '',
    title_en: this.vision.title_en || '',
    content_ar: this.vision.content_ar || '',
    content_en: this.vision.content_en || ''
  };


  this.apisService.editNabouttt(data).subscribe({
       next: () => {
    this.toastr.success(
      this.translate.instant('MENU.DASHBOARD.record_updated_successfully')
    );
  },
  error: (err) => {
    console.error('Update failed:', err);
    this.toastr.error(
      this.translate.instant('MENU.DASHBOARD.failed_to_update_record')
    );
  },
    });



}
 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.ads = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


}
